Foundation.Form.Validator.ReCaptcha = class {
  identifier () { return 'recaptcha' }

  validate (fieldElements) {
    const result = new Foundation.Promise()
    const errors = []

    fieldElements.each((_, elem) => {
      if (!elem.value) {
        errors.push('Please complete the reCAPTCHA test.')
      }
    })

    if (errors.length) result.failWith({errors})
    else result.fulfill()

    return result
  }
}

Foundation.Form.registerValidator(Foundation.Form.Validator.ReCaptcha)
